/**
 * ZALT Cart Drawer
 * AJAX cart using Shopify Cart API
 */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var closeBtns = document.querySelectorAll('[data-cart-drawer-close]');
  var emptyEl = document.querySelector('[data-cart-empty]');
  var itemsEl = document.querySelector('[data-cart-items]');
  var footerEl = document.querySelector('[data-cart-footer]');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var openBtns = document.querySelectorAll('[data-cart-drawer-open]');
  var checkoutBtn = document.querySelector('[data-cart-checkout]');

  var cart = null;

  /* Checkout destination. The PDP passes a promo-aware URL via
     openAfterAdd (flash/preorder ?discount= codes — see getCheckoutUrl in
     product-form-april.js). Defaults to plain /checkout everywhere else. */
  var checkoutUrl = '/checkout';

  /* ---- Subscription upsell data ----
     Emitted by cart-drawer-april.liquid: variant id -> first selling plan.
     Missing/empty blob disables the upsell entirely. */
  var upsellData = null;
  var upsellMap = {};
  (function () {
    var el = document.querySelector('[data-cart-upsell-json]');
    if (!el) return;
    try {
      upsellData = JSON.parse(el.textContent);
      upsellMap = upsellData.variants || {};
    } catch (e) {
      console.warn('Cart upsell: bad JSON, upsell disabled', e);
    }
  })();

  function upsellFor(item) {
    if (item.selling_plan_allocation) return null; // already a subscription
    return upsellMap[item.variant_id] || null;
  }

  /* ---- Legacy combined buy-box + cart treatment ----
     The buy-box-only relaunch keeps this implementation parked for possible
     future use, but buyboxMode() is hard-disabled so both Intelligems PDP arms
     render the same control drawer. Config still comes from
     [data-cart-buybox-json] (cart-drawer-april.liquid). */
  var buyboxConfig = null;
  (function () {
    var el = document.querySelector('[data-cart-buybox-json]');
    if (!el) return;
    try {
      buyboxConfig = JSON.parse(el.textContent);
    } catch (e) {
      console.warn('Cart buybox: bad JSON, enhancements disabled', e);
    }
  })();

  function buyboxMode() {
    return false;
  }

  var shipMeterEl    = document.querySelector('[data-ship-meter]');
  var shipMeterLabel = document.querySelector('[data-ship-meter-label]');
  var shipMeterFill  = document.querySelector('[data-ship-meter-fill]');
  var topupEl        = document.querySelector('[data-cart-topup]');
  var shippingRow    = document.querySelector('[data-cart-shipping-row]');
  var shippingAmount = document.querySelector('[data-cart-shipping-amount]');

  /* Free-shipping threshold evaluates the ACTUAL (post-discount) cart value
     (Dom 2026-06-12). Matches Shopify's native price-based threshold, so no
     Function is needed. Below the threshold the drawer never shows a rate
     ("Calculated at checkout") — checkout owns the number. */
  function freeShipUnlocked(cartValueCents) {
    return !!buyboxConfig && cartValueCents >= buyboxConfig.freeShipThresholdCents;
  }

  /* Cans per unit by handle — used for the "N cans" line-item label. */
  function cansForHandle(handle) {
    var c = BUYBOX_CANS_BY_HANDLE[handle];
    return typeof c === 'number' ? c : 0;
  }

  /* ---- Buy-box arm line items (mock: white rounded cards) ----
     Cans per unit by handle — drives the "N cans" line label. Sampler is 4
     (variety). Handles not listed are 0 cans and fall back to the Shopify
     product title for the label. */
  var BUYBOX_CANS_BY_HANDLE = {
    '4-pack-v2': 4,
    'electrolyte-pouches': 5,
    'zalt-3-pack': 3,
    'watermelon': 1,
    'cool-mint': 1,
    'cucumber-citrus': 1,
    'ginger-lime': 1
  };

  /* Cans in one unit of this line — mirrors buyboxLineConfig (sampler handle
     is 4 even if its handle isn't in the map). Drives the can-count label AND
     the minimum-order gate, so both read from one source. */
  function cansForItem(item) {
    var samplerHandle = buyboxConfig && buyboxConfig.samplerHandle;
    if (samplerHandle && item.handle === samplerHandle) return 4;
    return cansForHandle(item.handle);
  }

  /* Total cans across the cart (packs × size + singles × qty). */
  function cartCanCount() {
    if (!cart || !cart.items) return 0;
    var n = 0;
    cart.items.forEach(function (item) { n += cansForItem(item) * item.quantity; });
    return n;
  }

  var BX_CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"></path></svg>';
  var BX_TRASH_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"></path></svg>';
  var BX_CHEVRON_L = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"></path></svg>';
  var BX_CHEVRON_R = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"></path></svg>';

  function buyboxLineConfig(item) {
    var plan = item.selling_plan_allocation ? 'Subscribe & Save · ships monthly' : 'One-time';
    var samplerHandle = buyboxConfig && buyboxConfig.samplerHandle;
    if (samplerHandle && item.handle === samplerHandle) {
      return { name: '4-Can Sampler', sub: '4 cans · ' + plan };
    }
    var cans = cansForHandle(item.handle);
    if (cans) {
      var cansLabel = cans + (cans === 1 ? ' can' : ' cans');
      var name = item.variant_title ? item.variant_title + ' · ' + cansLabel : cansLabel;
      return { name: name, sub: cansLabel + ' · ' + plan };
    }
    return {
      name: item.product_title,
      sub: (item.variant_title ? item.variant_title + ' · ' : '') + plan
    };
  }

  function buyboxLineHtml(item) {
    var cfg = buyboxLineConfig(item);
    var subDiscount = lineDiscountCents(item);
    var html = '';
    html += '<div class="bxcart-line" data-line-key="' + item.key + '">';
    html += '  <div class="bxcart-line__top">';
    html += '    <span class="bxcart-line__thumb"><img src="' + getSizedImageUrl(item.image, '128x128') + '" alt="" width="58" height="58"></span>';
    html += '    <span class="bxcart-line__info">';
    html += '      <span class="bxcart-line__name">' + escapeHtml(cfg.name) + '</span>';
    html += '      <span class="bxcart-line__sub">' + escapeHtml(cfg.sub) + '</span>';
    html += '    </span>';
    html += '    <span class="bxcart-line__price">';
    if (subDiscount > 0) {
      html += '<span class="bxcart-line__was">' + formatMoney(lineOriginalCents(item)) + '</span>';
    }
    html += '      <span class="bxcart-line__now">' + formatMoney(lineDisplayCents(item)) + '</span>';
    html += '    </span>';
    html += '  </div>';
    html += '  <div class="bxcart-line__controls">';
    html += '    <span class="bxcart-qty">';
    html += '      <button data-qty-change="' + item.key + '" data-qty-dir="minus" aria-label="Decrease quantity">&minus;</button>';
    html += '      <span class="bxcart-qty__n">' + item.quantity + '</span>';
    html += '      <button data-qty-change="' + item.key + '" data-qty-dir="plus" aria-label="Increase quantity">+</button>';
    html += '    </span>';
    html += '    <button class="bxcart-line__remove" data-remove-item="' + item.key + '" aria-label="Remove item">' + BX_TRASH_SVG + '</button>';
    html += '  </div>';
    html += '</div>';
    return html;
  }

  function buyboxUpsellHtml(item, upsell) {
    var computedPct = upsell.basePrice > 0 ? Math.round((1 - upsell.price / upsell.basePrice) * 100) : 0;
    var pct = computedPct > 0 ? computedPct : (upsellData.labelPct || 0);
    var baseTotal = upsell.basePrice * item.quantity;
    var subTotal = upsell.price < upsell.basePrice
      ? upsell.price * item.quantity
      : Math.round(baseTotal * (1 - pct / 100));
    var html = '';
    html += '<div class="cart-upsell-card">';
    html += '  <span class="cart-upsell-card__tag">Most popular</span>';
    html += '  <span class="cart-upsell-card__title">Subscribe &amp; Save' + (pct > 0 ? ' an extra ' + pct + '%' : '') + '</span>';
    html += '  <ul class="cart-upsell-card__perks">';
    html += '    <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4L12 22 2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z"></path><circle cx="7.5" cy="7.5" r="1.3"></circle></svg>';
    html += '      <span>Instantly save ' + pct + '% on this order &mdash; ' + formatMoney(subTotal) + ' instead of ' + formatMoney(baseTotal) + '</span></li>';
    html += '    <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><path d="M3.3 7L12 12l8.7-5M12 22V12"></path></svg>';
    html += '      <span>Skip, swap or cancel anytime</span></li>';
    html += '  </ul>';
    html += '  <button type="button" class="cart-upsell-card__btn" data-upgrade-line="' + item.key + '">Upgrade and Save</button>';
    html += '</div>';
    return html;
  }

  /* cart_drawer_test A/B arm for analytics — resolved by window.ZaltAB
     (theme.liquid); 'control' when the helper is missing. */
  function getArm() {
    return (window.ZaltAB && typeof window.ZaltAB.getArm === 'function')
      ? window.ZaltAB.getArm()
      : 'control';
  }

  /* ---- Open / Close ---- */

  var lastFocused = null;

  function isOpen() {
    return drawer.classList.contains('is-open');
  }

  function open() {
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.removeAttribute('inert');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (closeBtns[0]) closeBtns[0].focus();
    fetchCart().then(fireViewCart).catch(function () { /* keep optimistic render */ });
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('inert', '');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  /* Open right after a PDP add-to-cart: render optimistically from the
     /cart/add.js response so the new line is visible immediately, then
     reconcile against /cart.js (fetched by open()). No blocking spinner. */
  function openAfterAdd(item, opts) {
    opts = opts || {};
    checkoutUrl = opts.checkoutUrl || '/checkout';

    if (item && item.key) {
      // Normalize fields render() depends on, in case the add.js response
      // omits them; the /cart.js reconcile corrects any drift anyway.
      if (typeof item.final_line_price !== 'number') {
        item.final_line_price = item.line_price || (item.price * item.quantity) || 0;
      }
      if (typeof item.original_line_price !== 'number') {
        item.original_line_price = item.final_line_price;
      }
      if (cart && cart.items) {
        var idx = cart.items.findIndex(function (i) { return i.key === item.key; });
        if (idx === -1) cart.items.unshift(item);
        else cart.items[idx] = item;
      } else {
        cart = { items: [item], currency: 'USD' };
      }
      // Recompute totals from lines; /cart.js will correct any drift.
      cart.item_count = 0;
      cart.total_price = 0;
      cart.items.forEach(function (i) {
        cart.item_count += i.quantity;
        cart.total_price += i.final_line_price;
      });
      render();
    }

    open();
    // open() captures document.activeElement; prefer the explicit trigger
    // so focus returns to the buy button on close.
    if (opts.trigger) lastFocused = opts.trigger;
  }

  function fireViewCart() {
    if (!cart || cart.items.length === 0) return;
    trackEvent('view_cart', {
      arm: getArm(),
      ecommerce: {
        currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD',
        value: cart.total_price / 100,
        items: cartToAnalyticsItems(cart.items)
      }
    });
  }

  openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
  closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
  if (overlay) overlay.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  /* Focus trap: keep Tab cycling inside the open dialog. */
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !isOpen()) return;
    var focusables = Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (focusables.length === 0) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ---- Shopify Cart API ---- */

  function fetchCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        render();
      });
  }

  function addItem(variantId, quantity, sellingPlanId) {
    var body = {
      id: variantId,
      quantity: quantity || 1
    };
    if (sellingPlanId) body.selling_plan = sellingPlanId;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        trackEvent('add_to_cart', {
          ecommerce: {
            currency: item.price > 0 ? 'USD' : 'USD',
            value: item.final_line_price / 100,
            items: [{
              item_id: item.product_id,
              item_name: item.product_title,
              item_variant: item.variant_title,
              price: item.final_price / 100,
              quantity: item.quantity
            }]
          }
        });
        fetchCart();
        open();
        return item;
      });
  }

  function changeItem(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart = data;
        render();
        return data;
      });
  }

  /* ---- Upgrade a one-time line to a subscription ----
     Converts the line in place via /cart/change.js with the variant's
     selling plan. Mirrors the PDP's subscription add (product-form-april.js):
     the line gets Skio's _dynamicBoxId/_dynamicBoxIndex properties so the
     resulting contract is a portal-editable Build-a-Box. */

  var skioBoxIdPromise = null;

  function skioBoxId() {
    if (skioBoxIdPromise) return skioBoxIdPromise;
    var pid = upsellData && upsellData.skioDynamicBoxProductId;
    if (!pid) {
      skioBoxIdPromise = Promise.resolve(null);
      return skioBoxIdPromise;
    }
    skioBoxIdPromise = fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productPlatformId: String(pid) })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var box = json && (json.DynamicBox || json.dynamicBox);
        if (box && box.boxId) return box.boxId;
        console.warn('Skio: get-dynamic-box returned no boxId', json);
        return null;
      })
      .catch(function (err) {
        console.warn('Skio: get-dynamic-box failed', err);
        return null;
      });
    return skioBoxIdPromise;
  }

  function upgradeLine(lineKey) {
    var item = cart && cart.items.find(function (i) { return i.key === lineKey; });
    var entry = item && upsellFor(item);
    if (!entry) return Promise.resolve();

    return skioBoxId()
      .then(function (boxId) {
        // change.js replaces line properties wholesale — merge, don't drop.
        var props = {};
        Object.keys(item.properties || {}).forEach(function (k) {
          props[k] = item.properties[k];
        });
        if (boxId) {
          props._dynamicBoxId = boxId;
          props._dynamicBoxIndex = 0;
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: lineKey,
            quantity: item.quantity,
            selling_plan: entry.sellingPlanId,
            properties: props
          })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/change failed: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        cart = data;
        render();
        trackEvent('upgrade_to_subscription', {
          arm: getArm(),
          ecommerce: {
            currency: 'USD',
            value: (entry.price * item.quantity) / 100,
            items: [{
              item_id: item.product_id,
              item_name: item.product_title,
              item_variant: item.variant_title,
              price: entry.price / 100,
              quantity: item.quantity
            }]
          }
        });
      })
      .catch(function (err) {
        console.warn('Cart upsell: upgrade failed', err);
        return fetchCart(); // re-render true server state (restores the pill)
      });
  }

  function removeItem(lineKey) {
    var item = cart ? cart.items.find(function(i) { return i.key === lineKey; }) : null;
    if (item) {
      trackEvent('remove_from_cart', {
        ecommerce: {
          currency: 'USD',
          value: item.final_line_price / 100,
          items: [{
            item_id: item.product_id,
            item_name: item.product_title,
            item_variant: item.variant_title,
            price: item.final_price / 100,
            quantity: item.quantity
          }]
        }
      });
    }
    return changeItem(lineKey, 0);
  }

  /* ---- Line discounts ----
     Shopify already applies automatic discounts to each line's
     `final_line_price` server-side. The drawer just reads what Shopify
     sends and reports the gap to `original_line_price` as the discount.
     Do NOT recompute or you'll double-discount.

     ANY line counts, selling plan or not: this helper used to require a
     selling_plan_allocation (it was built for the 30% sub automatic), so
     the V2 preorder automatic on one-time lines rendered as a bare $29.97
     with no strikethrough or discount row (Dom 2026-09-15). */

  function lineDiscountCents(item) {
    var orig  = item.original_line_price || item.final_line_price;
    var final = item.final_line_price;
    return Math.max(0, orig - final);
  }

  /* The customer-facing name of whatever automatic discount is on the cart
     (e.g. "V2 Preorder 25% Off"), straight from the cart payload so the
     drawer matches checkout without a theme push when the offer changes. */
  function cartDiscountLabel() {
    for (var i = 0; i < cart.items.length; i++) {
      var allocs = cart.items[i].line_level_discount_allocations || [];
      for (var j = 0; j < allocs.length; j++) {
        var app = allocs[j].discount_application;
        if (app && app.title) return app.title;
      }
    }
    return 'Discount';
  }

  function lineDisplayCents(item) {
    return item.final_line_price;
  }

  function lineOriginalCents(item) {
    return item.original_line_price || item.final_line_price;
  }

  /* ---- Rendering ---- */

  var titleEl = document.querySelector('.cart-drawer__title');

  function render() {
    if (!cart) return;

    updateCount(cart.item_count);

    /* Buy-box arm: mock styling hangs off a root class; header shows the
       item count ("Your cart (2)"). */
    drawer.classList.toggle('cart-drawer--bx', buyboxMode());
    // Buy-box single-scroll: move the totals out of the pinned footer into the
    // scroll region so it scrolls with the content; only the checkout CTA stays
    // pinned. Done once (appendChild is a no-op move if already there). Control
    // keeps its totals in the footer.
    if (buyboxMode()) {
      var bxScroll = drawer.querySelector('[data-cart-scroll]');
      var bxTotals = drawer.querySelector('[data-cart-totals]');
      if (bxScroll && bxTotals && bxTotals.parentElement !== bxScroll) bxScroll.appendChild(bxTotals);
    }
    if (titleEl) {
      titleEl.textContent = buyboxMode() && cart.item_count > 0
        ? 'Your cart (' + cart.item_count + ')'
        : 'Your cart';
    }

    if (cart.items.length === 0) {
      emptyEl.style.display = '';
      itemsEl.style.display = 'none';
      footerEl.style.display = 'none';
      // Totals may live in the scroll region (buy-box) where the footer's
      // display toggle can't reach it — hide it directly on empty.
      var bxTotalsEmpty = drawer.querySelector('[data-cart-totals]');
      if (bxTotalsEmpty) bxTotalsEmpty.style.display = 'none';
      renderShipMeter(0);
      renderTopup();
      return;
    }

    emptyEl.style.display = 'none';
    itemsEl.style.display = '';
    footerEl.style.display = '';
    var bxTotalsShow = drawer.querySelector('[data-cart-totals]');
    if (bxTotalsShow) bxTotalsShow.style.display = '';

    var html = '';
    cart.items.forEach(function (item) {
      // Buy-box arm: card layout per the mock — line card, then the
      // discount note under subscription lines, then the upsell card
      // under upgradable one-time lines.
      if (buyboxMode()) {
        html += buyboxLineHtml(item);
        if (item.selling_plan_allocation) {
          // Retention reassurance beats discount repetition here (Dom
          // 2026-07-06) — the line card's strikethrough already tells the
          // 30% story.
          html += '<p class="bxcart-note">' + BX_CHECK_SVG + '<span>Ships monthly. Cancel/modify at any time.</span></p>';
        }
        var bxUpsell = upsellFor(item);
        if (bxUpsell) html += buyboxUpsellHtml(item, bxUpsell);
        return;
      }

      var variantTitle = item.variant_title || '';
      var sellingPlanName = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : '';
      var subDiscount = lineDiscountCents(item);
      var displayLinePrice = lineDisplayCents(item);
      var originalLinePrice = lineOriginalCents(item);

      html += '<div class="cart-item" data-line-key="' + item.key + '">';
      html += '  <div class="cart-item__image">';
      html += '    <img src="' + getSizedImageUrl(item.image, '128x128') + '" alt="' + escapeHtml(item.product_title) + '" width="64" height="64">';
      html += '  </div>';
      html += '  <div class="cart-item__info">';
      html += '    <a href="' + item.url + '" class="cart-item__title">' + escapeHtml(item.product_title) + '</a>';
      if (variantTitle) {
        html += '    <span class="cart-item__variant">' + escapeHtml(variantTitle) + '</span>';
      }
      if (sellingPlanName) {
        html += '    <span class="cart-item__selling-plan">' + escapeHtml(sellingPlanName) + '</span>';
      }
      html += '  </div>';
      html += '  <div class="cart-item__actions">';
      if (subDiscount > 0) {
        html += '    <span style="display:flex;align-items:baseline;gap:0.375rem;">';
        html += '      <span class="cart-item__price-original">' + formatMoney(originalLinePrice) + '</span>';
        html += '      <span class="cart-item__price-discounted">' + formatMoney(displayLinePrice) + '</span>';
        html += '    </span>';
      } else {
        html += '    <span class="cart-item__price">' + formatMoney(displayLinePrice) + '</span>';
      }
      html += '    <div style="display:flex;align-items:center;gap:0.5rem;">';
      html += '      <div class="cart-item__quantity">';
      html += '        <button class="cart-item__qty-btn" data-qty-change="' + item.key + '" data-qty-dir="minus" aria-label="Decrease quantity">&minus;</button>';
      html += '        <span class="cart-item__qty-value">' + item.quantity + '</span>';
      html += '        <button class="cart-item__qty-btn" data-qty-change="' + item.key + '" data-qty-dir="plus" aria-label="Increase quantity">+</button>';
      html += '      </div>';
      html += '      <button class="cart-item__remove" data-remove-item="' + item.key + '" aria-label="Remove item">';
      html += '        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" /></svg>';
      html += '      </button>';
      html += '    </div>';
      html += '  </div>';
      var upsell = upsellFor(item);
      if (upsell) {
        // Allocation price == full price here (the sub discount is a
        // cart-level automatic discount), so prefer the computed percent
        // only when it's real; otherwise use the configured label percent.
        var computedPct = upsell.basePrice > 0 ? Math.round((1 - upsell.price / upsell.basePrice) * 100) : 0;
        var pct = computedPct > 0 ? computedPct : (upsellData.labelPct || 0);
        html += '  <button type="button" class="cart-item__upsell" data-upgrade-line="' + item.key + '">';
        html += 'Upgrade to Subscribe' + (pct > 0 ? ' &amp; Save ' + pct + '%' : '');
        html += '</button>';
      }
      html += '</div>';
    });

    itemsEl.innerHTML = html;
    bindItemEvents();
    renderTotals();
    renderTopup();
    syncCheckoutHref();
  }

  /* ---- Buy-box arm: free-shipping meter + top-up rail ---- */

  function renderShipMeter(cartValueCents) {
    if (!shipMeterEl) return;
    var show = buyboxMode() && buyboxConfig.meterEnabled &&
      cart && cart.items.length > 0;
    shipMeterEl.style.display = show ? '' : 'none';
    if (!show) return;

    var threshold = buyboxConfig.freeShipThresholdCents;
    var free = cartValueCents >= threshold;
    shipMeterEl.classList.toggle('is-unlocked', free);
    shipMeterLabel.innerHTML = free
      ? '<b>You’ve unlocked free shipping!</b>'
      : 'You’re <span class="cart-drawer__shipmeter-amt">' + formatMoney(threshold - cartValueCents) + '</span> away from <b>free shipping!</b>';
    shipMeterFill.style.width = Math.min(100, Math.round((cartValueCents / threshold) * 100)) + '%';
  }

  /* ---- Smart top-up picker ----
     Suggest a single can the shopper is most likely to want, never one
     that's redundant with what they're already buying. Rules, in order:
       1. Skip any candidate that's out of stock or already a line in the
          cart (don't re-suggest a flavor they just added).
       2. Prefer a flavor NOT yet represented anywhere in the cart — a GL
          sleeve should surface a different flavor, not more GL. This is the
          variety/discovery play.
       3. If every flavor is already represented (e.g. a variety sampler, or
          they bought all four), fall back to the top-priority in-stock
          candidate so the AOV rail still appears ("another can of X").
     Candidate order = the handles list in the section setting, so priority
     is editable without code. Returns the chosen candidate or null. */
  function cartFlavorState() {
    var present = {};      // flavor name -> in cart somewhere (sleeve/3-pack/sampler/can)
    var canInCart = {};    // flavor -> this exact top-up variant is already in the cart
    var cands = (buyboxConfig && buyboxConfig.topupCandidates) || [];
    var samplerHandle = buyboxConfig && buyboxConfig.samplerHandle;
    if (!cart || !cart.items) return { present: present, canInCart: canInCart };

    cart.items.forEach(function (item) {
      if (samplerHandle && item.handle === samplerHandle) {
        cands.forEach(function (c) { present[c.flavor] = true; });
        return;
      }
      var variantTitle = (item.variant_title || '').trim();
      cands.forEach(function (c) {
        if (item.variant_id === c.variantId) {
          present[c.flavor] = true;
          canInCart[c.flavor] = true;       // exact top-up-variant match
        } else if (variantTitle && variantTitle === c.flavor) {
          present[c.flavor] = true;          // sleeve / 3-pack of this flavor
        }
      });
    });
    return { present: present, canInCart: canInCart };
  }

  /* Up to `max` single-can candidates the shopper doesn't already have, in
     stock, variety-first (flavors not represented anywhere come before the
     rest), then priority order. Returns [] when there's nothing fresh to add. */
  function pickTopups(max) {
    var cands = (buyboxConfig && buyboxConfig.topupCandidates) || [];
    // HARD RULE: only ever upsell packs, never singles. A candidate with no packSize > 1
    // is a single can (or a stale/misconfigured blob) — drop it so a single can never
    // appears in the rail, even transiently. Packs (3-pack etc.) carry packSize.
    var inStock = cands.filter(function (c) { return c.available && c.variantId && c.packSize > 1; });
    if (inStock.length === 0) return [];
    var st = cartFlavorState();
    // never re-suggest a single can already in the cart
    var pool = inStock.filter(function (c) { return !st.canInCart[c.flavor]; });
    if (pool.length === 0) return [];
    // prefer flavors not represented anywhere; else keep priority order
    var fresh = pool.filter(function (c) { return !st.present[c.flavor]; });
    var rest  = pool.filter(function (c) { return st.present[c.flavor]; });
    return fresh.concat(rest).slice(0, max || 3);
  }

  /* Post-discount item total — the SAME basis the meter + freeShipUnlocked use
     (renderTotals sums lineDisplayCents identically), so the top-up's "this
     crosses the threshold" prediction lines up exactly with the meter flipping
     to unlocked after the can is added. */
  function cartDisplayCents() {
    if (!cart || !cart.items) return 0;
    var c = 0;
    cart.items.forEach(function (item) { c += lineDisplayCents(item); });
    return c;
  }

  /* Add one can (qty 1) of a top-up candidate. Shared by every flavor tile in
     the rail. `isFreeShip` flags adds that cross the threshold, for analytics. */
  function addTopupCan(c, isFreeShip, btn) {
    var label = 'Add ' + formatMoney(c.price);
    // The card is the button; update just its price pill, not the whole card.
    var labelEl = btn.querySelector('[data-topup-price]') || btn;
    btn.disabled = true;
    labelEl.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: c.variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add failed: ' + r.status);
        return r.json();
      })
      .then(function (item) {
        trackEvent('add_to_cart', {
          arm: getArm(),
          pdp_arm: 'buybox',
          cart_topup: true,
          topup_freeship_unlock: isFreeShip,
          topup_flavor: c.flavor,
          ecommerce: {
            currency: 'USD',
            value: item.final_line_price / 100,
            items: [{
              item_id: item.product_id,
              item_name: item.product_title,
              item_variant: item.variant_title,
              price: item.final_price / 100,
              quantity: item.quantity
            }]
          }
        });
        return fetchCart();
      })
      .catch(function () {
        btn.disabled = false;
        labelEl.textContent = label;
      });
  }

  /* Multi-flavor top-up rail. Show several 3-pack flavors the shopper doesn't
     have yet — each a one-time add, variety-first (singles aren't sellable). The
     free-shipping meter at the top carries the exact gap; this rail's heading
     ties the adds to that goal. When one pack add would cross the threshold the
     rail goes accent + "unlock" wording (same lineDisplayCents basis as the
     meter, so the promise holds). Candidates carry packSize (=3); cansForItem
     counts an added 3-pack as 3 cans toward the meter + MOQ gate. */
  function renderTopup() {
    if (!topupEl) return;
    var picks = (buyboxMode() && cart && cart.items.length > 0)
      ? pickTopups((buyboxConfig && buyboxConfig.maxTopupFlavors) || 3)
      : [];
    topupEl.style.display = picks.length ? '' : 'none';
    if (!picks.length) {
      topupEl.innerHTML = '';
      return;
    }

    var threshold = (buyboxConfig && buyboxConfig.meterEnabled) ? buyboxConfig.freeShipThresholdCents : 0;
    var cartCents = cartDisplayCents();
    var gap = threshold - cartCents;                  // > 0 = short of free shipping
    var shortOfFree = threshold > 0 && gap > 0;
    function crosses(c) { return shortOfFree && (cartCents + c.price) >= threshold; }
    // within one can: any single add crosses (candidates share the can price)
    var oneCanCrosses = picks.some(crosses);

    // Below the can minimum, checkout is blocked (same gate as applyCheckoutMoq),
    // so the rail's job is to clear that minimum — not free shipping. Lead with
    // the MOQ ask; it takes precedence over the free-shipping framing.
    var minCans = (buyboxConfig && buyboxConfig.minCans) || 0;
    var cansNeeded = minCans - cartCanCount();
    var belowMoq = minCans > 0 && cansNeeded > 0;

    // Singles aren't sellable, so the only addable unit is the top-up pack. The MOQ ask
    // must name that unit (an exact can count is unachievable when adds jump by the pack
    // size). railUnit comes from config (single source), falling back to the pick's packSize.
    var railUnit = (buyboxConfig && buyboxConfig.topupUnitLabel)
      || ((picks[0] && picks[0].packSize) ? picks[0].packSize + '-pack' : 'can');
    var head;
    if (belowMoq) {
      head = 'Add a ' + railUnit + ' to checkout';
    } else if (!shortOfFree) {
      head = 'Top up your order';
    } else {
      head = oneCanCrosses
        ? 'Add a ' + railUnit + ' to unlock free shipping'
        : 'Add ' + railUnit + 's to unlock free shipping';
    }

    var cards = '';
    picks.forEach(function (c) {
      var unit = c.packSize ? c.packSize + '-pack' : 'can';
      cards +=
        '<button type="button" class="cart-topup-card" data-topup-add' +
        ' aria-label="Add a ' + unit + ' of ' + escapeHtml(c.flavor) + ' for ' + formatMoney(c.price) + '">' +
        '  <span class="cart-topup-card__thumb">' + (c.image ? '<img src="' + c.image + '" alt="">' : '') + '</span>' +
        '  <span class="cart-topup-card__name">' + escapeHtml(c.flavor) + '</span>' +
        '  <span class="cart-topup-card__sub">' + escapeHtml(unit) + '</span>' +
        '  <span class="cart-topup-card__add" data-topup-price>Add ' + formatMoney(c.price) + '</span>' +
        '</button>';
    });

    topupEl.innerHTML =
      '<div class="cart-topup-rail' + (oneCanCrosses ? ' cart-topup-rail--freeship' : '') + '">' +
      '  <p class="cart-topup-rail__head' + (shortOfFree || belowMoq ? ' cart-topup-rail__head--fs' : '') + '">' + head +
      '    <span class="cart-topup-rail__note">One-time add-ons — never recur</span>' +
      '  </p>' +
      '  <div class="cart-topup-slider">' +
      '    <button type="button" class="cart-topup-slider__arrow cart-topup-slider__arrow--prev" data-topup-prev aria-label="Scroll left">' + BX_CHEVRON_L + '</button>' +
      '    <div class="cart-topup-track" data-topup-track>' + cards + '</div>' +
      '    <button type="button" class="cart-topup-slider__arrow cart-topup-slider__arrow--next" data-topup-next aria-label="Scroll right">' + BX_CHEVRON_R + '</button>' +
      '  </div>' +
      '</div>';

    // Cards render in the same order as picks — zip them by index.
    var btns = topupEl.querySelectorAll('[data-topup-add]');
    btns.forEach(function (btn, i) {
      var c = picks[i];
      btn.addEventListener('click', function () { addTopupCan(c, crosses(c), btn); });
    });

    setupTopupSlider();
  }

  /* Wire the top-up slider: arrows scroll the track by one card, and they
     hide when there's nothing to scroll (≤ what fits) and disable at each end.
     Measured live because the drawer may render while hidden (0-width); every
     open() re-fetches → re-renders → re-measures, so it self-corrects. */
  function setupTopupSlider() {
    if (!topupEl) return;
    var track = topupEl.querySelector('[data-topup-track]');
    if (!track) return;
    var prev = topupEl.querySelector('[data-topup-prev]');
    var next = topupEl.querySelector('[data-topup-next]');

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 2;
      if (prev) prev.style.display = overflow ? '' : 'none';
      if (next) next.style.display = overflow ? '' : 'none';
      if (!overflow) return;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    function step(dir) {
      var card = track.querySelector('.cart-topup-card');
      var amt = card ? card.offsetWidth + 8 : 120; // card width + 0.5rem track gap
      track.scrollBy({ left: dir * amt, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* A ?discount= code applies to the entire checkout. Promo codes are for
     one-time purchases only (mirrors the PDP rule), so never send one when
     any subscription line is in the cart — it could stack onto the Skio
     selling-plan price. */
  function syncCheckoutHref() {
    if (!checkoutBtn) return;
    var hasSubscription = !!(cart && cart.items && cart.items.some(function (i) {
      return i.selling_plan_allocation;
    }));
    checkoutBtn.setAttribute('href', hasSubscription ? '/checkout' : checkoutUrl);
  }

  /* Minimum-order gate (buy-box arm). A cart below the can minimum — e.g. left
     with just 1–2 singles after a pack is removed — can't check out: the button
     is disabled (greyed, click + keyboard blocked) and relabeled with the ask.
     Client-side UX only; hard enforcement needs a Shopify cart-validation
     Function (see plan note). Returns true when checkout is allowed. */
  function applyCheckoutMoq(finalCents) {
    if (!checkoutBtn) return true;
    var minCans = (buyboxConfig && buyboxConfig.minCans) || 0;
    var cans = (cart && cart.items.length > 0) ? cartCanCount() : 0;
    var blocked = minCans > 0 && cart && cart.items.length > 0 && cans < minCans;
    checkoutBtn.classList.toggle('is-disabled', blocked);
    if (blocked) {
      // Ask for the addable top-up unit, not an exact can count (adds jump by the pack size).
      var unit = (buyboxConfig && buyboxConfig.topupUnitLabel) || '3-pack';
      checkoutBtn.setAttribute('aria-disabled', 'true');
      checkoutBtn.textContent = 'Add a ' + unit + ' to checkout';
    } else {
      checkoutBtn.removeAttribute('aria-disabled');
      checkoutBtn.textContent = 'Checkout — ' + formatMoney(finalCents);
    }
    return !blocked;
  }

  function renderTotals() {
    var totalsEl          = document.querySelector('[data-cart-totals]');
    var originalRow       = document.querySelector('[data-cart-original-row]');
    var originalAmount    = document.querySelector('[data-cart-original-amount]');
    var subDiscountRow    = document.querySelector('[data-sub-discount-row]');
    var subDiscountAmount = document.querySelector('[data-sub-discount-amount]');
    var finalAmount       = document.querySelector('[data-cart-final-amount]');
    var finalNote         = document.querySelector('[data-cart-final-note]');
    if (!finalAmount) return;

    var originalCents = 0;
    var discountCents = 0;
    var finalCents = 0;
    cart.items.forEach(function (item) {
      originalCents += lineOriginalCents(item);
      finalCents    += lineDisplayCents(item);
      discountCents += lineDiscountCents(item);
    });

    if (discountCents > 0) {
      var label = cartDiscountLabel();
      var labelEl = document.querySelector('[data-discount-label]');
      if (originalRow)    originalRow.style.display = '';
      if (originalAmount) originalAmount.textContent = formatMoney(originalCents);
      if (subDiscountRow) subDiscountRow.style.display = '';
      if (labelEl)        labelEl.textContent = label;
      if (subDiscountAmount) subDiscountAmount.textContent = '−' + formatMoney(discountCents);
      if (finalNote) {
        finalNote.textContent = label + ' is applied automatically at checkout.';
        finalNote.style.display = '';
      }
    } else {
      if (originalRow)    originalRow.style.display = 'none';
      if (subDiscountRow) subDiscountRow.style.display = 'none';
      if (finalNote)      finalNote.style.display = 'none';
    }

    /* Buy-box arm: show free vs calculated-at-checkout shipping (by can
       count) and surface the free-shipping meter. Control sees the original
       item-only total. */
    if (buyboxMode()) {
      var freeShip = freeShipUnlocked(finalCents);
      if (shippingRow) {
        shippingRow.style.display = '';
        shippingAmount.textContent = freeShip ? 'FREE SHIPPING' : 'Calculated at checkout';
        shippingAmount.classList.toggle('cart-drawer-april-totals__free', freeShip);
        shippingAmount.classList.toggle('cart-drawer-april-totals__calc', !freeShip);
      }
      // Surface the subscription savings (Grüns-style): the generic block above
      // shows Subtotal = full price, Discount = −savings, and the "applied at
      // checkout" note. Carts with no sub savings fall back to Subtotal = Total.
      if (discountCents <= 0 && originalRow) {
        originalRow.style.display = '';
        if (originalAmount) originalAmount.textContent = formatMoney(finalCents);
      }
      applyCheckoutMoq(finalCents);
    } else if (shippingRow) {
      shippingRow.style.display = 'none';
    }

    if (totalsEl) totalsEl.classList.toggle('has-discount', discountCents > 0 || buyboxMode());

    finalAmount.textContent = formatMoney(finalCents);
    renderShipMeter(finalCents);
  }

  function bindItemEvents() {
    itemsEl.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-qty-change');
        var dir = btn.getAttribute('data-qty-dir');
        var item = cart.items.find(function (i) { return i.key === key; });
        if (!item) return;
        var newQty = dir === 'plus' ? item.quantity + 1 : item.quantity - 1;
        if (newQty < 1) {
          removeItem(key);
        } else {
          changeItem(key, newQty);
        }
      });
    });

    itemsEl.querySelectorAll('[data-remove-item]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Loading state: dim the line + spinner until the cart refetch re-renders.
        var line = btn.closest('[data-line-key]');
        if (line) line.classList.add('is-removing');
        btn.disabled = true;
        removeItem(btn.getAttribute('data-remove-item'));
      });
    });

    itemsEl.querySelectorAll('[data-upgrade-line]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        btn.textContent = 'Upgrading…';
        upgradeLine(btn.getAttribute('data-upgrade-line'));
      });
    });
  }

  /* ---- Cart count badge ---- */

  function updateCount(count) {
    countEls.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ---- Helpers ---- */

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    if (url.indexOf('_' + size) !== -1) return url;
    var match = url.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if (match) {
      var prefix = url.split(match[0]);
      return prefix[0] + '_' + size + match[0];
    }
    return url;
  }

  function trackEvent(name, data) {
    if (typeof window.trackEvent === 'function') {
      window.trackEvent(name, data);
    } else if (window.dataLayer) {
      window.dataLayer.push(Object.assign({ event: name }, data));
    }
  }

  function cartToAnalyticsItems(items) {
    return items.map(function (item) {
      return {
        item_id: item.product_id,
        item_name: item.product_title,
        item_variant: item.variant_title,
        price: item.final_price / 100,
        quantity: item.quantity
      };
    });
  }

  /* ---- Checkout tracking ---- */

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      // Minimum-order gate: block navigation (covers keyboard Enter, which
      // pointer-events:none can't stop) and skip tracking when disabled.
      if (checkoutBtn.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        return;
      }
      if (cart && cart.items.length > 0) {
        trackEvent('begin_checkout', {
          arm: getArm(),
          ecommerce: {
            currency: 'USD',
            value: cart.total_price / 100,
            items: cartToAnalyticsItems(cart.items)
          }
        });
      }
    });
  }

  /* ---- Initial load ---- */
  fetchCart();

  /* ---- Re-sync hooks ----
     Without these, the cached `cart` variable goes stale when the customer:
       1. Navigates to /checkout and hits the back button — the browser
          restores the page from BFCache with our old JS state intact.
       2. Switches tabs and comes back after editing the cart elsewhere
          (e.g. mobile companion tab, customer portal).
     pageshow with event.persisted === true fires only on BFCache restores.
     visibilitychange covers tab-return on the same document. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) fetchCart();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') fetchCart();
  });

  /* ---- Public API ---- */
  window.ZaltCart = {
    open: open,
    close: close,
    openAfterAdd: openAfterAdd,
    addItem: addItem,
    changeItem: changeItem,
    removeItem: removeItem,
    refresh: fetchCart
  };
})();
